import { useState, ChangeEvent, FormEvent, useEffect } from 'react';
import Spinner from 'components/Spinner/Spinner';
import { useAppSelector } from 'app/hooks';
import { Div } from 'styles/Styles';
import { FormTitle } from '../Auth.styled';
import { colors } from 'styles/GlobalStyles';
import { H2, P1 } from 'styles/FontStyles';
import { InputComponent } from 'components/Input/Input';
import { CountryDropdown } from '../CountryDropdown';
import { Button } from 'components/Button/Button';
import { signInGoogleComlete } from 'services/auth/auth.service';
import { useAppDispatch } from 'app/hooks';
import { useNavigate } from 'react-router';

export const GoogleComplete = () => {
  const [username, setUsername] = useState<string>('');
  const [country, setCountry] = useState<any>('');
  const [googleUser, setGoogleUser] = useState<{
    firstName: string;
    lastName: string;
  }>({
    firstName: '',
    lastName: '',
  });

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { loading, user } = useAppSelector((state) => state.authentication);

  const letterUpercaseAndSpace = /^[a-zA-Z\s]*$/;

  const onFormSubmit = (e: FormEvent) => {
    e.preventDefault();

    if (!user?.firstName || !user?.lastName) {
      dispatch(
        signInGoogleComlete({
          googleUser,
          username,
          country,
          navigate,
        })
      );
    } else {
      dispatch(
        signInGoogleComlete({
          user,
          username,
          country,
          navigate,
        })
      );
    }
  };

  const handleFirstNameChange = (value: string) => {
    setGoogleUser((prevUser) => ({ ...prevUser, firstName: value }));
  };

  const handleLastNameChange = (value: string) => {
    setGoogleUser((prevUser) => ({ ...prevUser, lastName: value }));
  };

  const checkFirstName = (e: string) => {
    if (e.match(letterUpercaseAndSpace)) {
      handleFirstNameChange(
        e
          .replace(/|[0-9]/g, '')
          .toLowerCase()
          .split('profile_details. ')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      );
    } else {
      return;
    }
  };

  const checkLastName = (e: string) => {
    if (e.match(letterUpercaseAndSpace)) {
      handleLastNameChange(
        e
          .replace(/|[0-9]/g, '')
          .toLowerCase()
          .split('profile_details. ')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      );
    } else {
      return;
    }
  };

  return (
    <>
      {loading && <Spinner fullscreen={true} transparent />}
      <Div $box $width='50%' $widthSM='100%'>
        <H2 center m='50px 0' color={colors.primary}>
          Profile Details
        </H2>
        <P1 color={colors.white} center mb='40'>
          Please complete your Google registration
        </P1>
        <form onSubmit={onFormSubmit}>
          <Div $flex $gap='10px' $width='100%' $columnSM $gapSM='0'>
            {(!user?.firstName || !user?.lastName) && (
              <>
                <Div $width='100%'>
                  {' '}
                  <InputComponent
                    placeholder='Name'
                    label='First name'
                    value={googleUser.firstName}
                    onChange={(e: ChangeEvent<HTMLInputElement>) =>
                      checkFirstName(e.target.value)
                    }
                  />{' '}
                </Div>
                <Div $width='100%'>
                  <InputComponent
                    placeholder='Surname'
                    label='Last name'
                    value={googleUser.lastName}
                    onChange={(e: ChangeEvent<HTMLInputElement>) =>
                      checkLastName(e.target.value)
                    }
                  />
                </Div>
              </>
            )}
          </Div>
          <InputComponent
            placeholder='Username'
            label='Username'
            value={username}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setUsername(e.target.value)
            }
          />
          <CountryDropdown country={country} setCountry={setCountry} label />
          <Button style={{ marginTop: 20 }} type='submit'>
            Sign In
          </Button>
        </form>
      </Div>
    </>
  );
};
